<template>
    <div v-if="isInit">
        <template v-if="visitInfo">
            <v-row class="a10-apply-view">
                <v-col cols="12" md="6">
                    <v-card class="pa-4 visit-info-card">
                        <v-card-title class="pa-0 mb-2">신청인 정보</v-card-title>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>방문신청 ID</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.visitId }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>성명</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.agentName }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>휴대폰</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.agentMobile | phone }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>소속 업체명</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.agentCompany }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card class="pa-4 visit-info-card">
                        <v-card-title class="pa-0 mb-2">방문 정보</v-card-title>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>방문목적</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.purpose }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>방문 일정</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.startDatetime | moment('YYYY-MM-DD A hh:mm') }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>방문 업체</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.visitCompanyName }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>방문할 지역</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.visitAreaName }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>접견자</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.visitDeptName }} {{ visitInfo.visitUserName }} {{ visitInfo.visitTitleName }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </v-col>
                <v-col cols="12">
                    <v-card class="pa-4 visit-info-card">
                        <v-card-title class="pa-0 mb-2">방문자</v-card-title>
                        <v-data-table
                            :headers="visitorHeaders"
                            :items="visitors"
                            :items-per-page="-1"
                            :disable-sort="$vuetify.breakpoint.smAndDown"
                            item-key="id"
                            no-data-text="등록된 방문자가 없습니다."
                            mobile-breakpoint="900"
                            hide-default-footer
                        >

                            <template v-slot:item.visitorName="{ item }">
                                <v-chip v-if="item.vip === 'Y'"
                                        x-small
                                        color="red"
                                        text-color="white"
                                        class="mr-1"
                                >
                                    VIP
                                </v-chip>
                                {{ item.visitorName }}
                            </template>

                            <template v-slot:item.visitorMobile="{ item }">
                                {{ item.visitorMobile | phone }}
                            </template>

                            <template v-slot:item.checkDateTime="{ item }">
                                {{ item.checkDateTime | moment('YYYY-MM-DD HH:mm') }}
                            </template>

                            <template v-slot:item.status="{ item }">
                                <div v-if="!['APPROVED', 'REJECTED', 'CANCELED'].includes(item.visitStatus)">
                                    <v-chip
                                        v-if="item.educationDateTime"
                                        small
                                        color="#4CAF50"
                                        text-color="white"
                                    >
                                        교육이수완료
                                    </v-chip>
                                    <v-chip
                                        v-if="item.vip !== 'Y' && !item.educationDateTime"
                                        small
                                        outlined
                                        color="#828282"
                                    >
                                        교육이수전
                                    </v-chip>
                                </div>
                                <div v-else>
                                    <v-chip small
                                            :color="getStatusInfo(item.visitStatus).backgroundColor"
                                            :text-color="getStatusInfo(item.visitStatus).color"
                                    >{{ getStatusInfo(item.visitStatus).text }}
                                    </v-chip>
                                    <div v-if="['REJECTED', 'CANCELED'].includes(item.visitStatus)">
                                        <span class="void-reason"
                                              @click="$window.alert(item.voidReason, 'info')">
                                            사유: {{ item.voidReason }}
                                        </span>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:item.actions="{ item }">
                                <span v-if="viewType === 'BACKOFFICE'" style="white-space: nowrap">
                                    <template v-if="item.visitStatus === 'PENDING' && (item.vip === 'Y' || item.educationDateTime)">
                                        <v-btn outlined small @click.stop="approveConfirm(item)" class="mr-2" color="primary">
                                            승인
                                        </v-btn>
                                        <v-btn outlined small @click.stop="rejectConfirm(item)" color="error">
                                            반려
                                        </v-btn>
                                    </template>
                                    <template v-if="item.visitStatus === 'APPROVED'">
                                        <v-btn outlined small @click.stop="rejectConfirm(item)" color="error">
                                            반려
                                        </v-btn>
                                    </template>
                                </span>

                                <span v-if="viewType === 'SEARCH'" style="white-space: nowrap">
                                    <template v-if="item.visitStatus === 'APPROVED'">
                                        <v-btn
                                            outlined
                                            small
                                            color="#78BE20"
                                            :to="qrCode(item)"
                                        >
                                            <v-icon left small>mdi-qrcode</v-icon>
                                            QR 코드
                                        </v-btn>
                                    </template>
                                </span>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
                <v-col v-if="isUseImportItem" cols="12">
                    <v-card class="pa-4 visit-info-card">
                        <v-card-title class="pa-0 mb-2">반입물품 / 전자기기</v-card-title>
                        <v-data-table
                            :headers="carryInItemHeaders"
                            :items="carryInItems"
                            :items-per-page="-1"
                            item-key="importId"
                            :disable-sort="$vuetify.breakpoint.smAndDown"
                            no-data-text="반입 물품이 없습니다"
                            hide-default-footer
                            @click:row="showCarryInDialog"
                        >
                            <template v-slot:item.visitorId="{ item }">
                                {{ getVisitorName(item.visitorId) }}
                            </template>
                            <template v-slot:item.reason="{ item }">
                                <span class="reason">{{ item.reason }}</span>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>

            <carry-in-dialog
                v-model="dialog.show"
                :target-item="dialog.item"
                :visitors="visitors"
                readonly
                @close="closeCarryInDialog"
            ></carry-in-dialog>
        </template>
        <template v-else>
            <v-card class="pa-4 visit-info-card">
                <v-card-text>방문예약 정보가 없습니다.</v-card-text>
            </v-card>
        </template>
    </div>
</template>

<script>
import {mapState} from "vuex";
import ApplyActionMixin from "@/components/apply/ApplyActionMixin";
import ImportItemHelper from "@/service/importItemHelper";
import CarryInDialog from "@/components/CarryInDialog.vue";

export default {
    name: 'ApplyView',
    components: {CarryInDialog},
    mixins: [ ApplyActionMixin ],

    props: {
        visitId: Number,
        viewType: {
            type: String,
            default: "",
        }
    },

    data: () => ({
        isInit: false,
        isLoading: false,
        visitInfo: null,
        visitorHeaders: [
            {text: '방문자', value: 'visitorName'},
            {text: '휴대폰', value: 'visitorMobile'},
            {text: '업체', value: 'visitorCompany'},
            {text: '차량번호', value: 'visitorCarNumber'},
            {text: "실제 방문시간", value: 'checkDateTime', sortable: false},
            {text: "상태", value: 'status', sortable: false},
            {text: '', value: 'actions', width: 100, sortable: false},
        ],
        visitors: [],
        carryInItemHeaders: [
            {text: '방문자', value: 'visitorId', width: 150},
            {text: '물품종류', value: 'importType'},
            {text: '제조사', value: 'manufacturer'},
            {text: '모델명', value: 'model'},
            {text: '시리얼번호', value: 'serial'},
            {text: '사유', value: 'reason', width: 200},
        ],
        carryInItems: [],
        dialog: {
            show: false,
            item: null,
        }
    }),

    computed: {
        ...mapState(['currentUser', 'secretKey', 'iv']),
        fieldConfig() {
            return ImportItemHelper.parseImportItemColumnsConfig(this.$code.get('service.config.import_item_columns'))
        },
        isUseImportItem() {
            return this.$code.get('service.config.use_import_item') === 'Y';
        },
    },

    async created() {
        if (this.visitId) {
            await this.fetchApplyInfo(this.visitId)
        } else {
            this.$window.alert('신청 정보를 찾을 수 없습니다.');
        }

        this.carryInItemHeaders = ImportItemHelper.cleanUnusedHeaders(this.carryInItemHeaders, this.fieldConfig);
        this.isInit = true;
    },

    methods: {
        async reload() {
            await this.fetchApplyInfo(this.visitId);
        },

        async fetchApplyInfo(visitId) {
            this.visitors = [];
            this.carryInItems = [];
            this.$window.showLoading("로딩 중...");

            try {
                let { visitInfo, visitors, carryInItems} = await this.getApplyInfo(visitId);
                this.visitInfo = visitInfo;
                this.visitors = visitors;
                this.carryInItems = carryInItems;
            } catch(err) {
                this.$window.alert(err.message, 'error');
            } finally {
                this.$window.hideLoading();
            }
        },

        getVisitorName(visitorId) {
            const visitor = this.visitors.find(v => v.visitorId === visitorId);
            return visitor ? visitor.visitorName : null;
        },

        showCarryInDialog(carryInItem) {
            this.dialog.item = carryInItem;
            this.dialog.show = true;
        },

        // 반입 물품 관련 함수
        closeCarryInDialog() {
            this.dialog.item = null;
            this.dialog.show = false;
        },

        /**
         * 방문 승인
         *
         * @param visitor
         * @returns {Promise<void>}
         */
        async approveConfirm(visitor) {
            const result = await this.$window.confirm('방문을 승인 하시겠습니까?');

            if (!result) {
                return;
            }

            this.$window.showLoading('승인 중...');

            try {
                await this.approve(this.visitInfo, visitor);
                await this.fetchVisitorsAndImportItems(this.visitInfo.visitId);
                this.$emit('reloadItems');
                this.$window.alert('승인 되었습니다.');
            } catch(err) {
                this.$window.alert(err.message ? err.message : err, 'error');
            } finally {
                this.$window.hideLoading();
            }
        },

        /**
         * 방문 반려
         *
         * @param visitor
         * @returns {Promise<void>}
         */
        async rejectConfirm(visitor) {
            const reason = await this.$window.prompt('반려 사유를 입력해주세요.', true, '반려 사유');
            if (!reason) {
                return;
            }

            this.$window.showLoading('반려 중...');

            try {
                await this.reject(this.visitInfo, visitor, reason);
                await this.fetchVisitorsAndImportItems(this.visitInfo.visitId);
                this.$emit('reloadItems');
                this.$window.alert('반려 되었습니다.');
            } catch(err) {
                this.$window.alert(err.message ? err.message : err, 'error');
            } finally {
                this.$window.hideLoading();
            }
        },

        async fetchVisitorsAndImportItems(visitId) {
            const res = await this.$axios.get(`/v1/res/visit/visitors/${visitId}`)
            this.visitors = [ ... res.data.visitors ];
            const importItems = [ ... res.data.importItems ];

            this.visitors.forEach(visitor => {
                importItems
                    .filter(e => e.visitorId === visitor.visitorId)
                    .forEach(e => e['visitorName'] = visitor.visitorName);
            });

            this.importItems = importItems;
        },

        qrCode(visitor) {
            const encryptedVisitId = this.getEncryptedId(visitor.visitId);
            const encryptedVisitorId = this.getEncryptedId(visitor.visitorId);
            return `/home/qrcode/${encryptedVisitId}/${encryptedVisitorId}`;
        }
    }

}
</script>

<style>
.a10-apply-view .visit-info-card {
    height: 100%;
}
.a10-apply-view .v-list-item {
    padding: 0 8px;
}
.a10-apply-view .v-list-item__content {
    padding: 8px 0;
}
.a10-apply-view .v-list-item__title {
    font-size: 0.8rem;
    color: #707070;
    margin-bottom: 4px !important;
}
.a10-apply-view .v-list-item__subtitle {
    font-size: 1rem;
    color: #212121 !important;
}
.a10-apply-view .reason {
    display: block;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: inherit;
}
.a10-apply-view .void-reason {
    font-size: 0.8rem;
    color: #f44336;
}
</style>